import { classNames } from '@utils/classNames';

export function Tag({ text, className }: { text: string; className?: string }) {
  const fullClassName = classNames(
    'rounded-full bg-ivarioBlue py-1 px-2.5 text-white line-clamp-1',
    className,
  );
  return <div className={fullClassName}>{text}</div>;
}
